var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "layout" }, [
    _c(
      "div",
      { staticClass: "layout_nav" },
      [_c("Nav", _vm._b({}, "Nav", _vm.getRol, false))],
      1
    ),
    _c(
      "div",
      { staticClass: "layout_center" },
      [
        _c("div", { staticClass: "layout_row" }, [
          _c(
            "div",
            { staticClass: "layout_colum" },
            [_c("Welcome", _vm._b({}, "Welcome", _vm.getUser, false))],
            1
          ),
          _c(
            "div",
            { staticClass: "layout_colum" },
            [
              _c("div", { staticClass: "ctn_indicator" }),
              _c("Snackbar", {
                attrs: {
                  visible: _vm.getAlert.snackbar,
                  text: _vm.getAlert.text,
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "v-tabs",
          {
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          },
          [
            _c("v-tab", { key: "user" }, [_vm._v("Cuentas")]),
            _c("v-tab", { key: "profile" }, [_vm._v("Perfiles")]),
          ],
          1
        ),
        _c(
          "v-tabs-items",
          {
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          },
          [
            _c("v-tab-item", { key: "user" }, [
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { staticClass: "pa-0" }, [
                            _c(
                              "div",
                              { staticClass: "ctn_btn_new btn_left" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "btn_new",
                                    attrs: { color: "primary" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        _vm.newUserFlag = true
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-plus-circle-outline"),
                                    ]),
                                    _c("span", [_vm._v(" Crear Usuario ")]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "v-col",
                            { staticClass: "pa-0 py-3", attrs: { sm: "auto" } },
                            [
                              _c(
                                "div",
                                { staticClass: "ctn_indicator" },
                                [
                                  _c("Indicator", {
                                    attrs: {
                                      active: _vm.getListUsers.active,
                                      inactive: _vm.getListUsers.inactive,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("TableUser"),
                  _c("NewUser", {
                    attrs: { visible: _vm.newUserFlag },
                    on: {
                      close: function ($event) {
                        _vm.newUserFlag = false
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("v-tab-item", { key: "profile" }, [
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { staticClass: "pa-0" }, [
                            _c(
                              "div",
                              { staticClass: "ctn_btn_new btn_left" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "btn_new",
                                    attrs: { color: "primary" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        _vm.newProfileFlag = true
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-plus-circle-outline"),
                                    ]),
                                    _c("span", [_vm._v(" Crear perfil ")]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "v-col",
                            { staticClass: "pa-0 py-3", attrs: { sm: "auto" } },
                            [
                              _c(
                                "div",
                                { staticClass: "ctn_indicator" },
                                [
                                  _c("Indicator", {
                                    attrs: {
                                      active: _vm.getListProfile.active,
                                      inactive: _vm.getListProfile.inactive,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("TableProfile"),
                  _c("NewProfile", {
                    attrs: { visible: _vm.newProfileFlag },
                    on: {
                      close: function ($event) {
                        _vm.newProfileFlag = false
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }